document.addEventListener('DOMContentLoaded', function () {
let originalImageData = null;
let processedImageDataURL=null;

  let backoriginalImageData = null;
let backprocessedImageDataURL=null;
  
const inverseCheckbox = document.getElementById('inverseCheckbox');
const backinverseCheckbox = document.getElementById('backinverseCheckbox');

  function getBase64Image(img) {
  var canvas = document.createElement("canvas");
  canvas.width = img.width;
  canvas.height = img.height;
  var ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0);
  var dataURL = canvas.toDataURL("image/png");
  return dataURL;
}

  
/*
* @front image  @function
*convert image to convas
*/
    function handleImageUpload(event) {
      
       var file = event;
        if (file) {
             console.log('File selected:', file);
           
                var img = new Image();
                img.onload = function() {
                    var canvas = document.getElementById('imageCanvas');
                    var ctx = canvas.getContext('2d');
                    canvas.width = img.width;
                    canvas.height = img.height;
                    ctx.drawImage(img, 0, 0);
                    canvas.style.display = 'block';
                    console.log('Image loaded and drawn on canvas');
                    processImage();
                }
                img.src = event;
          
        }
    }
/* 
*back image @function
* convet image to convas
*/
      function backhandleImageUpload(event) {
      
       var file = event;
        if (file) {
             console.log('File selected:', file);
           
                var img = new Image();
                img.onload = function() {
                    var canvas = document.getElementById('imageCanvasback');
                    var ctx = canvas.getContext('2d');
                    canvas.width = img.width;
                    canvas.height = img.height;
                    ctx.drawImage(img, 0, 0);
                    canvas.style.display = 'block';
                    console.log('Image loaded and drawn on canvas');
                    backprocessImage();
                }
                img.src = event;
          
        }
    }

  /*
  * @front image processimage function
  */
  
function processImage() {
const canvas = document.getElementById('imageCanvas');
const ctx = canvas.getContext('2d');
originalImageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
const data = originalImageData.data;
const tolerance = 40;
let containsColors = false;
let containsColorsb = false;
for (let i = 0; i < data.length; i += 4) {
const r = data[i];
const g = data[i + 1];
const b = data[i + 2];

  if (r < tolerance && g < tolerance && b < tolerance) {
      data[i] = 0;
      data[i + 1] = 0;
      data[i + 2] = 0;
  
   } 
  else if (r > 255 - tolerance  && g > 255 - tolerance && b > 255 - tolerance ) {
        data[i + 3] = 0;
        // console.log('2');
    } else {
    // console.log('3');
    containsColors = true;
    }

}


if (containsColors == true) {

    for (let j = 0; j < data.length; j += 4) {
    
    if (data[j + 3] > 0) { // Non-transparent pixel
    data[j] = 0;
    data[j + 1] = 0;
    data[j + 2] = 0;
    }
    }
  ctx.putImageData(originalImageData, 0, 0);
   processedImageDataURL = canvas.toDataURL('image/png');
  $('#cropped_image').attr('src', processedImageDataURL);
  $('.front_crop').attr('src', processedImageDataURL);
  $('#uploaded-image').attr('src', processedImageDataURL);
applyTextureToBlackPixels(processedImageDataURL);
}else{
   ctx.putImageData(originalImageData, 0, 0);
  processedImageDataURL = canvas.toDataURL('image/png');
  $('#cropped_image').attr('src', processedImageDataURL);
  $('.front_crop').attr('src', processedImageDataURL);
   $('#uploaded-image').attr('src', processedImageDataURL);
  applyTextureToBlackPixels(processedImageDataURL);
} 

}

/*
* back image @function

*/

function backprocessImage() {
const canvas = document.getElementById('imageCanvasback');
const ctx = canvas.getContext('2d');
backoriginalImageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
const data = backoriginalImageData.data;
const tolerance = 40;
let containsColors = false;

for (let i = 0; i < data.length; i += 4) {
const r = data[i];
const g = data[i + 1];
const b = data[i + 2];

  if (r < tolerance && g < tolerance && b < tolerance) {
      data[i] = 0;
      data[i + 1] = 0;
      data[i + 2] = 0;
    // console.log('2');
    } else if (r > 255 - tolerance  && g > 255 - tolerance && b > 255 - tolerance ) {
        data[i + 3] = 0;
        // console.log('2');
    } else {
    // console.log('3');
    containsColors = true;
    }

}


if (containsColors == true) {

    for (let j = 0; j < data.length; j += 4) {
    
    if (data[j + 3] > 0) { // Non-transparent pixel
    data[j] = 0;
    data[j + 1] = 0;
    data[j + 2] = 0;
    }
    }
  ctx.putImageData(backoriginalImageData, 0, 0);
   backprocessedImageDataURL = canvas.toDataURL('image/png');
  $('#cropped_image').attr('src', backprocessedImageDataURL);
  $('.back_crop').attr('src', backprocessedImageDataURL);
  $('#buploaded-image').attr('src', backprocessedImageDataURL);
  backapplyTextureToBlackPixels(backprocessedImageDataURL);

}else{
   ctx.putImageData(backoriginalImageData, 0, 0);
  backprocessedImageDataURL = canvas.toDataURL('image/png');
  $('#cropped_image').attr('src', backprocessedImageDataURL);
  $('.back_crop').attr('src', backprocessedImageDataURL);
   $('#buploaded-image').attr('src', backprocessedImageDataURL);
  backapplyTextureToBlackPixels(backprocessedImageDataURL);
} 

}

  

/*
* @front image function
* texture @function
*/
  function applyTextureToBlackPixels(imageDataURL) {
  
    
    const imageCanvas = document.getElementById('imageCanvas');
    const ctx = imageCanvas.getContext('2d');

    const selected_colonam = $('.inner_varinat .color_items.active').attr('data-color');
     const textureUrl = getBase64Image(document.getElementById("colo64_"+selected_colonam));

    
    // const textureUrl = 'x.png'; // Replace with your actual texture image URL

    const img = new Image();
    img.onload = function () {
        // Draw the processed or inverted image onto the canvas
        ctx.clearRect(0, 0, imageCanvas.width, imageCanvas.height);
        ctx.drawImage(img, 0, 0, imageCanvas.width, imageCanvas.height);

        // Load the texture image
        const textureImg = new Image();
        textureImg.onload = function () {
            const tempCanvas = document.createElement('canvas');
            tempCanvas.width = imageCanvas.width;
            tempCanvas.height = imageCanvas.height;
            const tempCtx = tempCanvas.getContext('2d');

            // Draw the original image onto the temporary canvas
            tempCtx.drawImage(img, 0, 0);

            // Set the composite operation to "source-in" to apply texture only to black pixels
            tempCtx.globalCompositeOperation = 'source-in';
            tempCtx.drawImage(textureImg, 0, 0, imageCanvas.width, imageCanvas.height);

            // Draw the final image back onto the main canvas
            const finalImageData = tempCtx.getImageData(0, 0, tempCanvas.width, tempCanvas.height);
            ctx.putImageData(finalImageData, 0, 0);

            console.log('Texture applied to black pixels.');
          
          setTimeout(function () {
          const convertedimage = imageCanvas.toDataURL('image/png');
          $('#uploaded-image').attr('src',convertedimage);


  
var frontimginver = $('#uploaded-image').attr('src');
  var frontsplit= frontimginver.split(',')[1];
 
      var fcontentTypes = 'image/png';
 $.ajax({
      url:'http://aussiepal.leapoffaithtech.com/upload.php',
        type: 'POST',
        data: {
            image: frontsplit,
            contentType: fcontentTypes
        },
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
            
        },
        success: function(response) {
          console.log(response);
         
          $('.front_image_url').html('http://aussiepal.leapoffaithtech.com/'+response);
            $('.popup_alert').removeClass('active');
            $('.content_1').html('');
            $('.popup_alert .heading').css('display','block');
            $('.close_ok').css('display','block');
        },
        error: function(xhr, status, error) {
            console.error(error);
        }
    });
      
 

            
    },1000);

          
          
        };
        textureImg.src = textureUrl;
    };

    img.src = imageDataURL;
}


/*
* @back texture function()
*/

  function backapplyTextureToBlackPixels(imageDataURL) {
  
    
    const imageCanvas = document.getElementById('imageCanvasback');
    const ctx = imageCanvas.getContext('2d');

    const selected_colonam = $('.inner_varinat .color_items.active').attr('data-color');
     const textureUrl = getBase64Image(document.getElementById("colo64_"+selected_colonam));

    
    // const textureUrl = 'x.png'; // Replace with your actual texture image URL

    const img = new Image();
    img.onload = function () {
        // Draw the processed or inverted image onto the canvas
        ctx.clearRect(0, 0, imageCanvas.width, imageCanvas.height);
        ctx.drawImage(img, 0, 0, imageCanvas.width, imageCanvas.height);

        // Load the texture image
        const textureImg = new Image();
        textureImg.onload = function () {
            const tempCanvas = document.createElement('canvas');
            tempCanvas.width = imageCanvas.width;
            tempCanvas.height = imageCanvas.height;
            const tempCtx = tempCanvas.getContext('2d');

            // Draw the original image onto the temporary canvas
            tempCtx.drawImage(img, 0, 0);

            // Set the composite operation to "source-in" to apply texture only to black pixels
            tempCtx.globalCompositeOperation = 'source-in';
            tempCtx.drawImage(textureImg, 0, 0, imageCanvas.width, imageCanvas.height);

            // Draw the final image back onto the main canvas
            const finalImageData = tempCtx.getImageData(0, 0, tempCanvas.width, tempCanvas.height);
            ctx.putImageData(finalImageData, 0, 0);

            console.log('Texture applied to black pixels.');
          
          setTimeout(function () {
          const convertedimage = imageCanvas.toDataURL('image/png');
          $('#buploaded-image').attr('src',convertedimage);


  
var backinver = $('#buploaded-image').attr('src');
  var backsplit= backinver.split(',')[1];
 
      var bcontentTypes = 'image/png';
 $.ajax({
      url:'http://aussiepal.leapoffaithtech.com/upload.php',
        type: 'POST',
        data: {
            image: backsplit,
            contentType: bcontentTypes
        },
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
            
        },
        success: function(response) {
          console.log(response);
         
          $('.back_image_url').html('http://aussiepal.leapoffaithtech.com/'+response);
            $('.popup_alert').removeClass('active');
            $('.content_1').html('');
            $('.popup_alert .heading').css('display','block');
            $('.close_ok').css('display','block');
        },
        error: function(xhr, status, error) {
            console.error(error);
        }
    });
      
 

            
    },1000);

          
          
        };
        textureImg.src = textureUrl;
    };

    img.src = imageDataURL;
}



  

/* 
*front image inverse
*inverse @image functions
*/  
function invertBlackAndTransparent() {
    const imageCanvas = document.getElementById('imageCanvas');
    const ctx = imageCanvas.getContext('2d');
    const img = new Image();

    img.onload = function () {
        ctx.clearRect(0, 0, imageCanvas.width, imageCanvas.height);
        ctx.drawImage(img, 0, 0, imageCanvas.width, imageCanvas.height);
        const imageData = ctx.getImageData(0, 0, imageCanvas.width, imageCanvas.height);
        const data = imageData.data;

        for (let i = 0; i < data.length; i += 4) {
            const r = data[i];
            const g = data[i + 1];
            const b = data[i + 2];
            const a = data[i + 3];

            if (r === 0 && g === 0 && b === 0 && a > 0) {
                // Black pixel, make it transparent
                data[i + 3] = 0;
            } else if (a === 0) {
                // Transparent pixel, make it black
                data[i] = 0;
                data[i + 1] = 0;
                data[i + 2] = 0;
                data[i + 3] = 255;
            }
        }

        ctx.putImageData(imageData, 0, 0);

        console.log('Image inverted: black pixels to transparent, transparent to black.');

        // Send the inverted image to texture application
        const invertedDataURL = imageCanvas.toDataURL('image/png');
        applyTextureToBlackPixels(invertedDataURL);

      
    };

    img.src = processedImageDataURL;
}

/*
* @back image inverse
*/

  function backinvertBlackAndTransparent() {
    const imageCanvas = document.getElementById('imageCanvasback');
    const ctx = imageCanvas.getContext('2d');
    const img = new Image();

    img.onload = function () {
        ctx.clearRect(0, 0, imageCanvas.width, imageCanvas.height);
        ctx.drawImage(img, 0, 0, imageCanvas.width, imageCanvas.height);
        const imageData = ctx.getImageData(0, 0, imageCanvas.width, imageCanvas.height);
        const data = imageData.data;

        for (let i = 0; i < data.length; i += 4) {
            const r = data[i];
            const g = data[i + 1];
            const b = data[i + 2];
            const a = data[i + 3];

            if (r === 0 && g === 0 && b === 0 && a > 0) {
                // Black pixel, make it transparent
                data[i + 3] = 0;
            } else if (a === 0) {
                // Transparent pixel, make it black
                data[i] = 0;
                data[i + 1] = 0;
                data[i + 2] = 0;
                data[i + 3] = 255;
            }
        }

        ctx.putImageData(imageData, 0, 0);

        console.log('Image inverted: black pixels to transparent, transparent to black.');

        // Send the inverted image to texture application
        const invertedDataURL = imageCanvas.toDataURL('image/png');
        backapplyTextureToBlackPixels(invertedDataURL);

      
    };

    img.src = backprocessedImageDataURL;
}
/*
* inverse front image  @click functions
*/
 $(document).on('click','.s1',function (){$('#inverseCheckbox').trigger('click'); });
   inverseCheckbox.addEventListener('change', function () {
        $('.popup_alert').addClass('active');
      $('.content_1').html('Please wait the image is inverting');
       $('.popup_alert .heading').css('display','none');
       $('.close_ok').css('display','none');
        if (inverseCheckbox.checked) {
            invertBlackAndTransparent();
          $('.front_image_invert').html('Yes');
        } else {
            applyTextureToBlackPixels(processedImageDataURL);
         $('.front_image_invert').html('No');
        }
    });

/*
*inverse back image @click function
*/
$(document).on('click','.s2',function (){$('#backinverseCheckbox').trigger('click');});
  
     backinverseCheckbox.addEventListener('change', function () {
        $('.popup_alert').addClass('active');
      $('.content_1').html('Please wait the image is inverting');
       $('.popup_alert .heading').css('display','none');
       $('.close_ok').css('display','none');
        if (backinverseCheckbox.checked) {
            backinvertBlackAndTransparent();
          $('.back_image_invert').html('Yes');
        } else {
            backapplyTextureToBlackPixels(backprocessedImageDataURL);
          $('.back_image_invert').html('No');
        
        }
    });
  
/*
* accept button @function
*/

$(document).on('click','.accept_btn',function (){
    $("#inverseCheckbox").prop("checked",false);
    $("#backinverseCheckbox").prop("checked",false);

  /* if uploading image to front tab */
  if ($(".front_tab.tab_items.active")[0]){
 var cropped_imagewidth = document.getElementById("cropped_image");
    var hightcrop = cropped_imagewidth.height;
    var widthcrop = cropped_imagewidth.width;
    if( hightcrop >= 300 && widthcrop >= 300 )
    {
           $('.resizable').addClass('active');
  $(this).html('Uploading image.....');
  $(this).attr('disabled','disabled');
  $('.review_design_uploadimg .cancle_btn').attr('disabled','disabled');
  $('#cropbutton').attr('disabled','disabled');
  $('.invert_btn').attr('disabled','disabled');
    
var cropped_image = $('#cropped_image').attr('src');
  handleImageUpload(cropped_image);
  document.getElementById('inverseCheckbox').disabled = false;
  var checkimage = setInterval(function () {
  var frontimgurrl = $('#uploaded-image').attr('src');
             if(frontimgurrl != undefined){
               console.log('1hello');
                 var frontimgurrls = frontimgurrl.split(',')[1];
                var frontCrop = cropped_image.split(',')[1]; // Extract base64 part
    var fcontentType = 'image/png';
/* uploadng image into server */
    $.ajax({
      url:'http://aussiepal.leapoffaithtech.com/upload.php',
        type: 'POST',
        data: {
            image: frontimgurrls,
            contentType: fcontentType
        },
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
            
        },
        success: function(response) {
          console.log(response);
          $('.review_design_uploadimg .accept_btn').html(' <i class="fa fa-check"></i> <span>Accept</span>');
          $('.review_design_uploadimg .accept_btn').removeAttr('disabled');
          $('.review_design_uploadimg .cancle_btn').removeAttr('disabled');
          $('#cropbutton').removeAttr('disabled');
          $('.invert_btn').removeAttr('disabled');
          $('.front_image_url').html('http://aussiepal.leapoffaithtech.com/'+response);
          $('.front_image').attr('data-src',cropped_image);
          $('.front_image img.uploadingimg').attr('src',cropped_image);
          $('.front_image .conva_imgs').css('display','block'); 
          $('.back_tab').removeAttr('disabled');
          $('.cancle_btn').addClass('hide');
          // $('.review_design_uploadimg').addClass('hide');
          $('.review_design_uploadimg').removeClass('active');
          $('#preview_img').removeAttr('src');
          $('.input-options').removeClass('hide');
          $('.front_tab').addClass('hide');
          $('.back_tab').addClass('hide');
           $('.edit_front_tab').removeClass('hide');
          $('.edit_back_tab').removeClass('hide');
          $('.upload_nav_design .clear_btn').removeClass('hide');
          $('.upload_nav_design .clear_btn').removeAttr('disabled');
          $('.upload_nav_design .preview_btn').removeClass('hide');
          $('.upload_nav_design .preview_btn').removeAttr('disabled');
          $('.upload_nav_design .addtocart_box').addClass('hide');

          $('#inverseCheckbox').css('display','inline');
          $('#backinverseCheckbox').css('display','none');
         $('.inverse_color').css('display','block');
          $('.s1').css('display','inline');
          $('.s2').css('display','none');


          var front_text = $('.front_image .cstm_textup').html();    
// var back_text = $('.front_image .cstm_textup').html();

/* if logo and text added*/

  if(front_text !=''){
    $('.front_image').addClass('both_textactive');
  }

          
        },
        error: function(xhr, status, error) {
            console.error(error);
        }
    });
               clearInterval(checkimage);
             }
 }, 1000);
      
   
    }else{
     $('.popup_alert').addClass('active');
      $('.content_1').html('The image is too small. Please Crop an image that is a minimum of 300px in width and height, excluding whitespace.');
    }

    
  }

/* back image code */
 if ($(".back_tab.tab_items.active")[0]){

    var bcropped_imagewidth = document.getElementById("cropped_image");
    var bhightcrop = bcropped_imagewidth.height;
    var bwidthcrop = bcropped_imagewidth.width;
   console.log()
    if( bhightcrop >= 300 && bwidthcrop >= 300 )
    {
                                                     
    $('.resizable').addClass('active');
  $(this).html('Uploading image.....');
  $(this).attr('disabled','disabled');
  $('.review_design_uploadimg .cancle_btn').attr('disabled','disabled');
  $('#cropbutton').attr('disabled','disabled');
  $('.invert_btn').attr('disabled','disabled');
   var bropped_image = $('#cropped_image').attr('src');
 var backCrop = bropped_image.split(',')[1]; // Extract base64 part
 var bcontentType = 'image/png';
backhandleImageUpload(bropped_image);

var checkimageback = setInterval(function () {
   var backimgurrl = $('#buploaded-image').attr('src');
   if(backimgurrl != undefined){
var backCrops = backimgurrl.split(',')[1];
  $.ajax({
        url:'http://aussiepal.leapoffaithtech.com/upload.php',
        type: 'POST',
        data: {
            image: backCrops,
            contentType: bcontentType
        },
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
            
        },
        success: function(response) {
            console.log(response);
           // $('.back_uploaded_content').html('');
           $('.review_design_uploadimg .accept_btn').html(' <i class="fa fa-check"></i> <span>Accept</span>');
$('.review_design_uploadimg .accept_btn').removeAttr('disabled');
  $('.review_design_uploadimg .cancle_btn').removeAttr('disabled');
  $('#cropbutton').removeAttr('disabled');
  $('.invert_btn').removeAttr('disabled');
          $('.back_image_url').html('http://aussiepal.leapoffaithtech.com/'+response);
        $('.back_image').attr('data-src',cropped_image);
        $('.back_image img.uploadingimg').attr('src',cropped_image);
        
//    $('.back_image .conva_imgs').css('display','block'); 
        $('.back_tab').removeAttr('disabled');
        $('.cancle_btn').addClass('hide');
        $(this).addClass('hide');
        $('.clear_btn').removeClass('hide');
        $('.preview_btn').removeClass('hide');
        $('.clear_btn').removeAttr('disabled');
        $('.preview_btn').removeAttr('disabled');
        $('.review_design_uploadimg').removeClass('active');
          $('.back_image .conva_imgs').css('display','block'); 
        $('#preview_img').removeAttr('src');
        $('.input-options').removeClass('hide');   
          
          $('.front_tab').addClass('hide');
          $('.back_tab').addClass('hide');
           $('.edit_front_tab').removeClass('hide');
          $('.edit_back_tab').removeClass('hide');
          $('.upload_nav_design .clear_btn').removeClass('hide');
          $('.upload_nav_design .clear_btn').removeAttr('disabled');
          $('.upload_nav_design .preview_btn').removeClass('hide');
          $('.upload_nav_design .preview_btn').removeAttr('disabled');
     $('.upload_nav_design .addtocart_box').addClass('hide');
          $('#inverseCheckbox').css('display','none');
          $('#backinverseCheckbox').css('display','inline');
           $('#backinverseCheckbox').removeAttr('disabled');
          $('.inverse_color').css('display','block');
 $('.s2').css('display','inline');
          $('.s1').css('display','none');
                  
 var back_text = $('.back_image .cstm_textup').html();

/* if logo and text added*/

  if(back_text !=''){
    $('.back_image').addClass('both_textactive');
  }
        },
        error: function(xhr, status, error) {
            console.error(error);
        }
    });
     
     clearInterval(checkimageback);
   }
},1000);
 
    }else{
       $('.popup_alert').addClass('active');
      $('.content_1').html('The image is too small. Please Crop an image that is a minimum of 300px in width and height, excluding whitespace.');
    }
   
 }
  

  
  
});

});